import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AdsGETApi, AdsGETApiAuth, AdsPOSTApi } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { logout } from '../../../redux/action';

import { ExamBlock } from '../ExamBlock';

export default function AllWrittenExamList() {
  const [AllExamList1, setAllExamList1] = React.useState([]);
  const [AllExamListUnavailable, setAllExamListUnavailable] = React.useState([]);
  const [reload, setReload] = React.useState(false)
  const [choose, setChoose] = React.useState(0)
  const [Value, setValue] = React.useState(0)
  const [pagesLength, setPagesLength] = React.useState("1");
  const [pages, setPages] = React.useState(1);
  const dispatch = useDispatch()
  const [usersData, setUsersData] = React.useState({ meta: { number_of_exams: "0" } });
  const LoginState = useSelector((state) => state.LoginState);

  const fetchExam = (perPage, verifiedExamList) => {
    setReload(true)
    AdsGETApiAuth({
      per_page: 1000,
      order: "asc",
      _fields: "id,title,meta.featured_image,meta.available_unavailable,slug,meta.exam_type,meta.exam_time,meta.exam_question_block_student",
      "filter[meta_query][1][key]": "available_unavailable",
      "filter[meta_query][1][value][0]": "Available",
      "filter[meta_query][1][compare]": "=",
    }
      , slugs.db_slug_written_exam)
      .then((res) => {
        // setAllExamList(res.data)
        const examList = res.data
        // var verified = [];
        // var unverified = [];
        // for (let i = 0; i < examList.length; i++) {
        //   if (verifiedExamList.filter(a => a.exam_id == examList[i].id).length !== 0)
        //     verified.push(examList[i])
        //   else
        //     unverified.push(examList[i])
          setAllExamList1(res.data)
        // }
        setReload(false)
        // setPagesLength(res.headers["x-wp-totalpages"])
        // console.log(res.data.length)
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data)
        if (err.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
  }
  let myarray = []
  for (let i = 0; i < pagesLength; i++)
    myarray.push(
      <div key={i} style={{ margin: "3px" }}>
        <button onClick={() => {
          setPages(i + 1)
          setAllExamList1([])
          fetchExam(setAllExamList1, { page: i + 1, per_page: 100, order: "asc" })
        }}
          style={{ border: "0", padding: "7px", backgroundColor: pages == i + 1 ? "#0d02a6" : "#f00", color: "#fff", borderRadius: "5px" }}
        >
          {i + 1}
        </button>
      </div>
    )
  const location = useLocation()
  useEffect(() => {
    // AdsGETApiAuth({
    //   status: "any",
    //   "filter[meta_query][1][key]": "user_id",
    //   "filter[meta_query][1][value][0]": LoginState.userID,
    //   "filter[meta_query][1][compare]": "=",
    //   _fields: "meta"
    // }, "user_data")
    //   .then((response) => {
    //     if (response.data.length !== 0) {
    //       setUsersData(response.data[0])
    //       var verifiedExamListCache = response.data[0].meta.verified_exam_list
    //       var verifiedExamList;
    //       if (verifiedExamListCache == "")
    //         verifiedExamList = [];
    //       else
    //         verifiedExamList = JSON.parse(verifiedExamListCache)
    //     }
    fetchExam()
    //   })
    //   .catch(e => {
    //     if (e.message.includes("Request failed with status code 500"))
    //       dispatch(logout())
    //   })
    // console.log(location.pathname.slice(11))
  }, [])


  return (
    <div>
      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mt-3">
          <div className="row" style={{ margin: "10px" }}>
            <h2>All Written Exams</h2>
            {AllExamList1.map((item, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-6 center" style={{ padding: "0 5px" }}>
                <ExamBlock item={item} examSlug={slugs.start_written_exam} />
              </div>
            ))}
          </div>
          {AllExamListUnavailable.length != 0 &&
            <div className="row" style={{ margin: "10px" }}>
              <h2>Unavailable Exams</h2>
              {AllExamListUnavailable.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-4 col-6 center" style={{ padding: "0 5px" }}>
                  <ExamBlock item={item} examSlug={slugs.start_written_exam} />
                </div>
              ))}
            </div>
          }

          {pagesLength !== "1" &&
            <div className="" style={{ display: 'flex', flexDirection: 'row', margin: 10 }}>
              {myarray}
            </div>
          }
        </div>
      </div>

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}